import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import { FormsModule } from '@angular/forms';
import { MessageModule } from 'primeng/message';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { ProgressBarModule } from 'primeng/progressbar';
import { AppAccessdeniedComponent } from './app.accessdenied.component';
import { AppErrorComponent } from './app.error.component';
import { AppNotfoundComponent } from './app.notfound.component';
import { ExportActionsPanelComponent } from './shared/export-actions-panel/export-actions-panel.component';
import { DropdownPanelComponent } from './library/dropdown-panel/dropdown-panel.component';
import { TooltipDropdownComponent } from './library/tooltip-dropdown/tooltip-dropdown.component';
import { NewlineToBrPipe } from '@/common/pipes/newline-to-br.pipe';
import { SecondsToHoursMinutesPipe } from '@/common/pipes/seconds-to-hours-minutes.pipe';
import { SafePipe } from '@/common/pipes/safe-pipe';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PopoverModule } from 'primeng/popover';
import { RouterModule } from '@angular/router';
import { TagModule } from 'primeng/tag';
import { CardModule } from 'primeng/card';
import { Ripple } from 'primeng/ripple';
import { DateRangeSelectorComponent } from '@/common/shared/date-range-selector/date-range-selector.component';
import { DatePicker } from 'primeng/datepicker';
import { IntegrationNameKeyPipe } from '@/common/pipes/integration-name-key.pipe';

@NgModule({
    declarations: [
        AppAccessdeniedComponent,
        AppErrorComponent,
        AppNotfoundComponent,
        ExportActionsPanelComponent,
        DateRangeSelectorComponent,
        DropdownPanelComponent,
        TooltipDropdownComponent,
        NewlineToBrPipe,
        SecondsToHoursMinutesPipe,
        SafePipe,
    ],
    imports: [
        DividerModule,
        FormsModule,
        MessageModule,
        PasswordModule,
        ButtonModule,
        SelectModule,
        ProgressBarModule,
        CommonModule,
        TranslateModule,
        TooltipModule,
        ProgressSpinnerModule,
        PopoverModule,
        RouterModule,
        TagModule,
        CardModule,
        Ripple,
        DatePicker,
        IntegrationNameKeyPipe,
    ],
    exports: [
        AppAccessdeniedComponent,
        AppErrorComponent,
        AppNotfoundComponent,
        ExportActionsPanelComponent,
        DateRangeSelectorComponent,
        DropdownPanelComponent,
        TooltipDropdownComponent,
        NewlineToBrPipe,
        SecondsToHoursMinutesPipe,
        SafePipe,
        IntegrationNameKeyPipe,
    ],
})
export class AppCommonModule {}
